import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { AlertTriangle, X } from "lucide-react";

const KEY = "bmm_dismissed_alert";

export const AlertBanner = () => {
  const [alert, setAlert] = useState(null);

  useEffect(() => {
    api.get("/announcements").then((r) => {
      const urgent = (r.data || []).find((a) => a.priority === "high");
      if (urgent && localStorage.getItem(KEY) !== urgent.id) setAlert(urgent);
    }).catch(() => {});
  }, []);

  if (!alert) return null;

  const dismiss = () => { localStorage.setItem(KEY, alert.id); setAlert(null); };

  return (
    <div data-testid="global-alert-banner"
      className="flex items-start gap-2 border-b border-destructive/30 bg-destructive/10 px-4 py-2.5 text-destructive">
      <AlertTriangle size={17} className="mt-0.5 shrink-0" />
      <div className="flex-1">
        <p className="text-sm font-bold leading-tight">{alert.title}</p>
        <p className="text-xs leading-snug text-destructive/90">{alert.message}</p>
      </div>
      <button data-testid="dismiss-alert-btn" onClick={dismiss} aria-label="Dismiss alert"
        className="shrink-0 rounded-full p-1 hover:bg-destructive/15">
        <X size={16} />
      </button>
    </div>
  );
};
